 let remainingGuesses = 2;

 function selectNotes(clickedId) {
    if (clickedId === 'winner') {
        showWinModal("Bravo! \nClick me to continue.");
      showFireworksAnimation();
      	document.querySelector('.next-challenge').disabled = false;
    } else {
     remainingGuesses--
     updateGuessesRemaining();
     if (remainingGuesses === 1){
         showWinModal( `Sorry. \nClick me to continue!`);
     }
     else if (remainingGuesses === 0){
         showWinModal( "Uh oh :( \nKeep Trying\n");
         	document.querySelector('.next-challenge').disabled = false;
     }

     
    }
  }

function updateGuessesRemaining() {
  const guessesRemainingElement = document.getElementById('guessesRemaining');
  guessesRemainingElement.innerText = `Guesses remaining: ${remainingGuesses}`;
}

function showWinModal(message) {
  var modal = document.getElementById('winModal');
  const modalText=document.getElementById('outputText')
 
 modal.style.display = 'block';
   modalText.innerText=message;

  modalText.addEventListener('click', function() {
        modal.style.display = 'none';
    });
  
}

function showFireworksAnimation() {
  const fireworksContainer = document.getElementById('fireworks-container');
  fireworksContainer.style.display = 'block';

  // Define the fireworks colors
  const colors = ['#FF5733', '#E91E63', '#9C27B0', '#2196F3', '#00BCD4', '#4CAF50', '#FFC107'];

  // Create particles for the fireworks animation
  for (let i = 0; i < 100; i++) {
    const particle = document.createElement('div');
    particle.className = 'firework-particle';
    fireworksContainer.appendChild(particle);

    const color = colors[Math.floor(Math.random() * colors.length)];
    particle.style.backgroundColor = color;

    gsap.fromTo(
      particle,
      { x: 0, y: 0, opacity: 0 },
      {
        duration: Math.random() * 2 + 1,
        x: (Math.random() - 0.5) * 400,
        y: (Math.random() - 0.5) * 400,
        opacity: 1,
        ease: 'power4.out',
        onComplete: () => {
          fireworksContainer.removeChild(particle);
        },
      }
    );
  }

  // Hide the fireworks container after animation
  gsap.delayedCall(2.5, () => {
    fireworksContainer.style.display = 'none';
  });
}

function goToNextChallenge() {
  window.location.href = '/pages/challenge-part-2'
}

function goToDone() {
  window.location.href = '/pages/challenge-end'
}

